<template>
  <div class="dashboard__view merchant-list">
    <div class="page">
      <div class="relative">
        <div class="text-light">
          <p>
            Filter Statement by :
            <span @click="openFilters = !openFilters"
              >All Statement
              <svg
                width="10"
                height="6"
                viewBox="0 0 10 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                :class="openFilters ? '' : 'rotate'"
              >
                <path
                  d="M1 1L5 5L9 1"
                  stroke="#e00b5b"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </p>
        </div>
        <div class="filter-dropdown" v-if="openFilters">
          <div class="filter-title">Reference</div>
          <div class="form__item">
            <input
              class="form__input"
              type="text"
              v-model="filterList.reference"
            />
          </div>
          <div class="">
            <p class="filter-title">STATUS</p>
            <div
              v-for="status in statusGroup"
              class="status-element"
              :key="status.id"
              @click="() => (filterList.status = status.id)"
            >
              <p v-if="status.id === filterList.status">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="8" fill="#e00b5b" />
                  <path
                    d="M11 6L6.875 10L5 8.18182"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
              <p v-else>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="8" cy="8" r="7.5" stroke="#979797" />
                </svg>
              </p>
              <p class="filter-title">{{ status.name }}</p>
            </div>
          </div>
          <div>
            <p class="filter-title">Date</p>
            <div class="date-group">
              <div class="mt__10">
                <input
                  placeholder="Start Date"
                  class="date margin-right"
                  type="text"
                  onfocus="(this.type='date')"
                  id="start_date"
                  v-model="filterList.from"
                />
              </div>
              <div class="mt__10">
                <input
                  placeholder="End Date"
                  class="date"
                  type="text"
                  onfocus="(this.type='date')"
                  id="end_date"
                  v-model="filterList.to"
                />
              </div>
            </div>
          </div>
          <div class="button-group">
            <button
              class="btn woven-border-only woven-red"
              @click="clearFilter"
            >
              Reset Filter
            </button>
            <button class="btn woven-color" @click="triggerFilter">
              <p>Filter</p>
            </button>
          </div>
        </div>
      </div>
      <!--      <div class="page__title"></div>-->
      <div class="page__title__action d-flex">
        <router-link class="btn btn--primary" to="/dashboard/statements/create-single"
          >Create Statement Record</router-link
        >
        <button
            :disabled="exportDisabled || false"
            @click="exportData"
            class="btn btn--sm btn--flex btn-filter ml__20"
            v-if="statementList.length > 0"
        >
          <div class="btn--text" v-if="exportDisabled || false">
            Exporting...
          </div>
          <div class="btn--text" v-else>Export</div>
          <span class="btn--icon">
            {{ " " }} &nbsp;
            <svg
              fill="none"
              height="12"
              viewBox="0 0 14 18"
              width="14"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.25 0V12.4219L2.28906 8.46094L1.21094 9.53906L6.46094 14.7891L7 15.3047L7.53906 14.7891L12.7891 9.53906L11.7109 8.46094L7.75 12.4219V0H6.25ZM0.25 16.5V18H13.75V16.5H0.25Z"
                fill="#e00b5b"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>

    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <div class="tab__content__top__left">
            {{ pageInfo.total }} Statements
          </div>
          <div class="tab__content__top__right">
            <div class="tab__content__top__item">
              <p class="brand__text-color cr-pointer" @click="$router.push({ name: 'uploadHistory' });">View Upload History</p>
            </div>
          </div>
        </div>

        <EmptyState v-if="emptyState" type="not-found" icon="transaction" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <th>BANK</th>
                <th>STATUS</th>
                <th>REFERENCE</th>
                <th>AMOUNT</th>
                <th>RUNNING BALANCE</th>
                <th>TRANSACTION DATE</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr :key="key" v-for="(item, key) in statementList">
                <td @click="toggleDetailsModal(item)">
                  {{ item.bank_name }}
                </td>
                <td @click="toggleDetailsModal(item)">
                  <status-indicator-with-words-v2 :type="item.reconciliation_status" use-background-color />
                </td>
                <td @click="toggleDetailsModal(item)">
                  {{ item.transaction_reference }}
                </td>
                <td @click="toggleDetailsModal(item)">{{ item.amount }}</td>
                <td @click="toggleDetailsModal(item)">{{ item.running_balance }}</td>
                <td @click="toggleDetailsModal(item)">{{ item.transaction_date | date }}</td>
                <td class="act">
                  <b-dropdown
                    size="sm"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    right
                  >
                    <template #button-content>
                      <svg
                        width="4"
                        height="15"
                        viewBox="0 0 4 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.748 5.55929C1.51845 5.55929 1.29115 5.6045 1.07907 5.69235C0.866992 5.7802 0.674294 5.90895 0.511978 6.07127C0.349661 6.23359 0.220904 6.42628 0.133059 6.63836C0.0452134 6.85044 1.80758e-07 7.07774 1.80758e-07 7.30729C1.80758e-07 7.53684 0.0452134 7.76414 0.133059 7.97622C0.220904 8.1883 0.349661 8.381 0.511978 8.54331C0.674294 8.70563 0.866992 8.83439 1.07907 8.92223C1.29115 9.01008 1.51845 9.05529 1.748 9.05529C2.2116 9.05519 2.65617 8.87092 2.98391 8.54303C3.31165 8.21514 3.49571 7.77049 3.4956 7.30689C3.4955 6.8433 3.31123 6.39873 2.98334 6.07099C2.65546 5.74325 2.2108 5.55919 1.74721 5.55929H1.748ZM1.748 3.49441C1.97745 3.49431 2.20463 3.44901 2.41657 3.36111C2.62851 3.27321 2.82106 3.14442 2.98323 2.98211C3.1454 2.81979 3.27401 2.62712 3.36172 2.4151C3.44943 2.20308 3.49452 1.97586 3.49441 1.74641C3.49431 1.51697 3.44901 1.28979 3.36111 1.07785C3.27321 0.865905 3.14442 0.673353 2.98211 0.511183C2.81979 0.349014 2.62712 0.220403 2.4151 0.132694C2.20308 0.0449854 1.97586 -0.000104113 1.74641 1.80513e-07C1.28302 0.000210818 0.838699 0.184493 0.511183 0.512306C0.183667 0.84012 -0.00021045 1.28461 1.80758e-07 1.748C0.000210812 2.21139 0.184493 2.65571 0.512306 2.98323C0.84012 3.31074 1.28461 3.49462 1.748 3.49441V3.49441ZM1.748 11.1186C1.2844 11.1186 0.839791 11.3027 0.511978 11.6306C0.184164 11.9584 1.80758e-07 12.403 1.80758e-07 12.8666C1.80758e-07 13.3302 0.184164 13.7748 0.511978 14.1026C0.839791 14.4304 1.2844 14.6146 1.748 14.6146C2.2116 14.6146 2.65621 14.4304 2.98402 14.1026C3.31184 13.7748 3.496 13.3302 3.496 12.8666C3.496 12.403 3.31184 11.9584 2.98402 11.6306C2.65621 11.3027 2.2116 11.1186 1.748 11.1186V11.1186Z"
                          fill="#262626"
                        />
                      </svg>
                    </template>
                    <div
                      @click="
                        updateReconciliationStatus(
                          item.unique_identifier,
                          'RECONCILED'
                        )
                      "
                      class="act__item dropdown-item-list"
                    >
                      <span>Reconciled</span>
                    </div>
                    <div
                      @click="
                        updateReconciliationStatus(
                          item.unique_identifier,
                          'UNRECONCILED'
                        )
                      "
                      class="act__item dropdown-item-list"
                    >
                      <span>Unreconciled</span>
                    </div>
                    <div
                      @click="
                        updateReconciliationStatus(
                          item.unique_identifier,
                          'REVERSAL'
                        )
                      "
                      class="act__item dropdown-item-list"
                    >
                      <span>Reversal</span>
                    </div>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="table__details"
            v-if="loading !== true && emptyState !== true"
          >
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
                >Page {{ pageInfo.current_page }} of
                {{ pageInfo.total_pages }}</span
              >
            </div>
            <div class="table__details__right">
              <Pagination :numberOfPages="pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
    </div>
    <statement-details
      v-if="showDetailsModal"
      :showModal="showDetailsModal"
      @toggleModal="toggleDetailsModal"
      :details="selectedDetails"
    ></statement-details>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Pagination from "@/components/pagination.vue";
import Vue from "vue";
import EmptyState from "@/components/empty-state.vue";
import StatusIndicatorWithWordsV2 from "../../../components/statusIndicatorWithWordsV2";
import StatementDetails from "./statement-details";
export default {
  components: {
    StatementDetails,
    StatusIndicatorWithWordsV2,
    Datepicker,
    Pagination,
    EmptyState,
  },
  metaInfo: {
    title: "Statements",
  },
  data() {
    return {
      statementList: [],
      selectedDetails: {},
      pageInfo: "",
      perPage: 10,
      disabled: false,
      filterList: {
        reference: this.$route.query.referennce
          ? this.$route.query.reference
          : "",
        status: this.$route.query.status ? this.$route.query.status : "",
        to: this.$route.query.to ? this.$route.query.to : "",
        from: this.$route.query.from ? this.$route.query.from : "",
      },
      loading: true,
      emptyState: false,
      openFilters: false,
      showDetailsModal: false,
      statusGroup: [
        {
          id: "Reconciled",
          name: "Reconciled"
        },
        {
          id: "Unreconciled",
          name: "Unreconciled"
        },
        {
          id: "Reversal",
          name: "Reversal"
        }
      ],
      exportDisabled: false
    };
  },

  created() {
    this.fetchStatements();
  },

  watch: {
    // call again the fetch method if the route changes; this is necessary especially because of users
    // using the search and might be on this route already.
    $route: "fetchStatements",
  },

  computed: {
    userDetails() {
      return this.$store.state.userDetails;
    },
  },

  computed: {
    userDetails() {
      return this.$store.state.userDetails;
    },
  },

  methods: {
    updateReconciliationStatus(reference, status) {
      this.$http
        .put(
          `admin/reconciliation_status/update?unique_identifier=${reference}&reconciliation_status=${status.toUpperCase()}`
        )
        .then(response => {
              this.$notify({
                group: "notifications-default",
                type: "success text-white",
                title: "Success",
                text: "Statement updated succesfully"
              });
              this.fetchStatements();
        })
        .catch(error => {
              this.$notify({
                group: "notifications-default",
                // type: "error text-white",
                title: "Error",
                text: error.body.message
              });
        });
    },
    generatePaginationLink(pageNum) {
      return {
        path: "/dashboard/statements",
        query: {
          ...this.$route.query,
          page: pageNum,
        },
      };
    },
    toggleDetailsModal(selectedDetails) {
      this.selectedDetails = selectedDetails;
      this.showDetailsModal = !this.showDetailsModal;
    },
    triggerFilter() {
      let queryObject = {};
      if (this.filterList.reference !== "") {
        queryObject.transaction_reference = this.filterList.reference.trim();
      }
      if (this.filterList.status !== "") {
        queryObject.reconciliation_status = this.filterList.status;
      }
      if (this.filterList.to !== "") {
        queryObject.to = moment(this.filterList.to).format(
          "YYYY-MM-DD"
        );
      }
      if (this.filterList.from !== "") {
        queryObject.from = moment(this.filterList.from).format(
          "YYYY-MM-DD"
        );
      }

      queryObject.page = 1;

      this.openFilters = false;

      //Route to page with query
      this.$router.push({ path: "/dashboard/statements", query: queryObject });
    },
    clearFilter() {
      this.filterList = {
        reference: "",
        status: "",
        to: "",
        from: "",
      };
      this.$router.push({ path: "/dashboard/statements?page=1" });
    },
    fetchStatements() {
      // Convert object to multiple arrays with name and value
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      let appendedQuery = "";
      this.loading = true;
      // Loop through arrays and generate the query string
      for (const [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }

      // // check for mode to append query
      if (this.mode) {
          appendedQuery = "&ignore_admin_flag=1";
      } else {
          appendedQuery = "&ignore_admin_flag=1&is_test=1";
      }

      this.$http
        .get(`admin/statement?${generatedQuery}${appendedQuery}`)
        .then(response => {
          if (response.body.data.statement.length > 0) {
            this.statementList = response.body.data.statement;
            this.pageInfo = response.body.data.page_info;
            this.emptyState = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.emptyState = true;
          }
        })
        .catch(error => {
          // LOG Error
          this.loading = false;
        });
    },
    returnQuery() {
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }
      return generatedQuery;
    },
    exportData() {
      this.exportDisabled = true;
      let generatedQuery = this.returnQuery();
      let url = process.env.VUE_APP_API_URL;
      const token = this.userDetails.token;
      url = `${url}/admin/statement?download=true&token=${token}&${generatedQuery}`;
      window.open(url);
      setTimeout(() => {
        this.exportDisabled = false;
        this.$notify({
          group: "notifications-default",
          type: "success text-white",
          title: "Success",
          text: "Exporting in progress please wait..",
        });
      }, 3000);
    },
    pollDownload(identifier) {
      this.$http.get(`dashboard/downloads/${identifier}`).then((response) => {
        // if data is available stop polling
        this.exportDisabled = false;
        clearInterval(this.polling);
        window.location.assign(response.body.data.file_url);
      });
    },
    resetState() {
      this.fullName.empty = false;
      this.businessName.empty = false;
      this.mobileNumber.empty = false;
      this.businessNuban.empty = false;
      this.password.empty = false;
      this.emailAddress.empty = false;
    },
    clearData() {
      this.fullName.value = "";
      this.businessName.value = "";
      this.mobileNumber.value = "";
      this.businessNuban.value = "";
      this.password.value = "";
      this.emailAddress.value = "";
    },

    deactivate(value, key) {
      // Since Arrays are not reactively we have to manually update the data.
      // (variable, array position, value)
      Vue.set(this.deactivateDisabled, [key], true);
      let requestObject = {
        status: "BLOCKED",
        id: value.id,
      };
      this.$http
        .put("admin/merchants", requestObject)
        .then((response) => {
          // Undisable button
          Vue.set(this.deactivateDisabled, [key], false);
          // Notifiy user
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          // Update merchant list
          this.fetchMerchants();
        })
        .catch((error) => {
          Vue.set(this.deactivateDisabled, [key], false);
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
        });
    },
    activate(value, key) {
      Vue.set(this.activateDisabled, [key], true);
      let requestObject = {
        status: "ACTIVE",
        id: value.id,
      };
      this.$http
        .put("admin/merchants", requestObject)
        .then((response) => {
          // Undisable button
          Vue.set(this.activateDisabled, [key], false);
          // Notifiy user
          this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: response.body.message,
          });
          // Update merchant list
          this.fetchMerchants();
        })
        .catch((error) => {
          Vue.set(this.activateDisabled, [key], false);
          this.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
        });
    },
    toggleMerchantStatus(value, key) {
      if (value.status !== "BLOCKED" && value.status !== "INACTIVE") {
        this.deactivate(value, key);
      } else {
        this.activate(value, key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.merchant-list {
  .create-merchant-btn {
    position: absolute;
    right: 20px;
    top: 10px;
  }
  .dropdown-item-list {
    display: flex;
    align-items: center;
    span {
      display: inline;
      padding-left: 10px;
    }
  }
  .pending {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #b59b00;
  }
  .name {
    color: #261940;
    display: block;
    margin-bottom: 4px;
  }

  .email {
    color: rgba(38, 25, 64, 0.6);
    font-size: 12px;
  }

  .page__link {
    color: rgba(38, 25, 64, 0.6);
    font-size: 14px;
    line-height: 20px;
    padding: 12px 24px;
    text-decoration: none;
    display: block;
    &:hover {
      color: #e00b5b;
    }
  }
}
.text-green {
  color: #29d450 !important;
}

.ml__20 {
  margin-left: 20px;
}

.brand__text-color {
  color: #ff7176;
}

.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;

  span {
    color: #e00b5b;
    cursor: pointer;
  }
}

.relative {
  position: relative;
}
.end-date {
  margin-top: 15px;
}
.rotate {
  transform: rotate(180deg);
}
.woven-color {
  background: #e00b5b;
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;

  svg {
    margin-right: 5px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}
.woven-strip {
  position: absolute;
  left: 0;
}
.woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;
  height: 40px;
  svg {
    margin-left: 5px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #e00b5b;
  }
}

.filter-dropdown {
  background: #fff;
  padding: 20px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 30px;
  z-index: 100;
  right: 0;
  min-width: 300px;
  .form__item {
    margin-bottom: 16px;
  }
}

.woven-red {
  color: #e00b5b;
}
.button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-top: 32px;
  border-top: 1px solid rgba(196, 196, 196, 0.5);
  p {
    width: 100%;
  }
  .btn {
    width: 100px;
    height: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    padding: 10px;
    text-align: center;
  }
}
.date-group {
  display: block;
}
.margin-right {
  margin-right: 16px;
}
.date {
  border: 0.5px solid rgba(97, 110, 124, 0.5);
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(97, 110, 124, 0.8);
  padding: 12px 10px;
  width: 100%;
}
.status-element {
  display: flex;
  svg {
    margin-right: 10px;
    cursor: pointer;
  }
}
.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  span {
    color: #e00b5b;
    cursor: pointer;
  }
}
.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  color: #9a9fa3;
  // margin-bottom: 16px;
  margin: 5px 0;
}
// filter styles end
.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */
    color: #e00b5b;
    cursor: pointer;
  }
}

.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.toggle-date {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #595959;
  text-transform: capitalize !important;
  display: flex;
  .date {
    margin: 0 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 150% */

    color: #e00b5b;
    cursor: pointer;
  }
}
.btn-filter {
  height: 50px;
  border: 1px solid #fd8387;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent !important;
}
.no-bg {
  background: none !important;
}

.modal-body {
  justify-content: center !important;
  h2 {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;
  }

  p {
    margin-bottom: 31px;
    color: #616e7c;
  }

  svg {
    margin-bottom: 12px;
  }

  textarea {
    resize: none;
    height: 4rem;
  }

  .boxed {
    width: 60%;
    margin: 0.5rem auto 1.5rem;
    .form__flex__item,
    button {
      margin-left: 0;
      width: 100%;
    }

    .details__card__item {
      padding: 0 0 24px;
      border: none;
    }
  }
}

.mt__10 {
  margin-top: 10px;
}

.cr-pointer {
  cursor: pointer;
}

.page {
  align-items: flex-end !important;
}
</style>
